import styled from 'styled-components'
import { colors } from 'styles'
import StyledButton from 'components/Button/StyledButton'

const StyledPagination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .page {
    text-decoration: none;
    font-size: 1.6rem;
    color: ${colors.textSecondary};
    opacity: 0.6;

    &:hover,
    &--active {
      opacity: 1;
    }
    ~ .page {
      margin-left: 1.5rem;
    }
  }
  .page--active {
    font-weight: 700;
    color: ${colors.textMain};
  }
  .dots {
    color: ${colors.textSecondary};
  }
  /* prettier-ignore */
  ${StyledButton}:not([disabled]) {
    opacity: 0.6;
    transition: 0.3s;
    &:hover {
      opacity: 1;
    }
  }
`

export default StyledPagination
